<template>
  <div v-if="refs.results && refs.results.length > 1" class="rate-indicator">

    <div class="rate-indicator--info">
      <div v-if="category" class="rate-indicator--category rate-indicator--counter">
        {{ category }}: <span class="rate-indicator-mobile">{{ voteCounter + 1 }} из {{ refs.results.length }}</span>
      </div>

      <div @click="changeSlide(key)" v-for="ref, key in refs.results" :class="`rate-indicator--info-button`">
          <div :class="`rate-indicator--info-ball rate-indicator--info-ball-dir-${tempRefs[key] && tempRefs[key].value ? tempRefs[key].value > 300 : 'standard'} rate-indicator--info-ball-${slide === key ? 'active' : ''} rate-indicator--info-button-${voteCounter < key ? 'next' : ''}`"/>
      </div>

      <div @click="nextImage()" class="rate-indicator--info-next">Пропустить шаг</div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from '@/store/mutation-types';

import findObj from '@/utils/objects';

export default {
  name: 'RateIndicator',
  computed: mapGetters({
    personIsAdmin: 'personIsAdmin',
    personCurrent: 'personCurrent',
    voteCounter: 'voteCounter',
    tempRefs: 'tempRefs',
    slide: 'slide',
    tags: 'tags',
    refs: 'refs',
  }),
  metaInfo() {
    return {
      title: this.category,
    };
  },
  data() {
    return {
      size: 1,
      category: '',
    };
  },
  mounted() {
    this.category = this.getCategoryBySlug(this.$route.params.slug);
  },
  methods: {
    getCategoryBySlug(slug) {
      const tag = findObj(this.tags, slug, 'tag');
      return tag.name;
    },

    calcProgress() {
      const w = document.body.clientWidth;
      const buttonsW = ((w / 100) * 5) * 2;
      return ((w / this.refs.results.length) * this.voteCounter) - buttonsW;
    },
    changeSlide(key) {
      if (key <= this.voteCounter && key !== this.slide) {
        this.$store.commit('VOTE_BUSY', true);
        setTimeout(() => {
          this.$store.commit('VOTE_BUSY', false);
          this.$store.commit('VOTE_SLIDE', key);
        }, 500);
      }
    },

    deleteImage() {
      this.$store.commit(types.TEMP_REF, {
        ref: {},
        value: null,
      });
      this.nextImage();
    },

    nextImage() {
      this.$store.commit('VOTE_BUSY', true);
      setTimeout(() => {
        this.$store.commit('VOTE_BUSY', false);
        this.$store.commit('INCREASE_COUNTER');
        if (this.voteCounter >= this.refs.results.length) {
          this.$store.dispatch('voteRefs');
          this.$router.push(`/accounts/${this.personCurrent.id}/`);
        }
      }, 500);
    },
  },
};
</script>

<style>
.rate-indicator{

  transition: all .3s ease-in-out;
  text-align: center;
  color: black;
  position: fixed;
 
  width: 100%;
  z-index: 99;
  bottom: 25px;
  left: 0;

  @media (max-width: 600px) {
    bottom: 10px;
  }

  &-mobile{
    display: none;
    @media (max-width: 600px) {
      display: block;
    }
  }



  &--category{
    display: inline-block;
    position: relative;
    
    margin: 0 8px;
    color: black;
  }

  &--counter{

    white-space: nowrap;
    display: inline-block;
    padding: 3px 4px 0px;
    position: relative;
    border-radius: 6px;
    white-space: nowrap;
  }

  &--category{
    left: 0;
  }

  &--info{
    background: rgba(255,255,255,1);
    padding: 10px 9px 11px;
    display: inline-block;
    border-radius: 30px;
    position: relative;
    text-align: center;
    margin: 0 auto;
    max-width: 80%;
    font-size: 80%;

    &-delete{
      transition: all .3s ease-in-out;
      display: inline-block;
      img{
        margin-right: 4px;
        margin-left: 4px;
        margin-top: -1px;
        width: 11px;
      }
      &:hover{
        transform: scale(1.4);
      }
    }

    &-next{
      transition: all .3s ease-in-out;
      display: inline-block;
      margin: -1px -3px -4px 7px;
      transition: all .3s ease-in-out;
      /* background: #d7d6d6; */
      border-radius: 15px;
      padding: 6px 11px 3px;
      cursor: pointer;
      &:hover{
        background: #999999;
        color: white;
      }
    }

    &-ball{
      transition: all .3s ease-in-out;
      border-radius: 50%;
      background: #999;
      cursor: pointer;
      height: 10px;
      width: 10px;


      @media (max-width: 600px) {
        height: 0;
        width: 0;
        margin: 0;
      }

      @media (max-width: 600px) {
        display: none;
      }

      &:hover{
         transform: scale(1.5);
      }
      &-active{
        &,
        &:hover{
          background: #999;
          visibility: visible;
          transform: scale(2);
          cursor: auto;
          opacity: 1;
        }
      }
      &-dir{
        &-true{
          &,
          &hover{
            background: #6acd1d !important;
          }
        }
        &-false{
          
          &,
          &hover{
            background: #fd7373;
          }
        }
      }
    }


    &-button{
      display: inline-block;
      vertical-align: top;
      margin: 8px 5px 0;
      opacity: 1;
      @media (max-width: 600px) {
        margin: 0;
      }
      &-next{
        background: #ccc;
        cursor: auto;
        &:hover{
          transform: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Indicator.vue?2250c0ca